export default __webpack_public_path__ + "static/9-82a77ff7d1d3e626d9b05f35bd097ed2.jpg";